/**
 * Resolves sourceId for Payroll2 API calls (getPayrollBids, holdBySource).
 * COMMISSIONSTATEMENT bids are filtered by order id on the server; CLIENTPAYMENT/ADJUSTMENT by debitNote.
 * Commission-statement bids may still populate debitNote (from the order), so we must not prefer debitNote for that sourceType.
 */
export function getPayrollSourceIdForApi(item) {
  if (!item) return null;
  if (item.sourceType === "COMMISSIONSTATEMENT") {
    return item.order?._id || item.key;
  }
  if (item.sourceType === "ADJUSTMENT") {
    return item.debitNote?._id || item.key;
  }
  return item.debitNote?._id || item.order?._id || item.key;
}

/** True when bid was released from another payroll's holding pool. */
export function isPoolReleasedPayrollBid(bid, payrollId) {
  if (!bid?.originalPayroll || !payrollId) return false;
  const originalId = bid.originalPayroll._id || bid.originalPayroll;
  return originalId.toString() !== payrollId.toString();
}

/** Bids generated for this payroll (excludes pool-released bids). */
export function isNativePayrollBid(bid, payrollId) {
  return !isPoolReleasedPayrollBid(bid, payrollId);
}

/** Format hold/release dates for payroll bid display. */
export function formatPayrollBidDate(date) {
  if (!date) return "-";
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("en-CA");
}

/** Held date including lastHeldAt preserved after pool release. */
export function formatPayrollBidHeldDate(bid) {
  return formatPayrollBidDate(bid?.lastHeldAt || bid?.heldAt);
}
